import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { color } from "@m/alchemy-theme";
export const TableCol = styled(({ borderLeft, borderRight, highlight, width, ...props }) => (_jsx("col", { ...props }))) `
  background-color: ${({ highlight, ...props }) => highlight ? color("hint", { palette: "expressiveInformative" })(props) : "unset"};
  ${({ width }) => width && `width: ${width};`}
  ${({ borderLeft }) => borderLeft && `border-left: ${borderLeft};`}
  ${({ borderRight }) => borderRight && `border-right: ${borderRight};`}
`;
